import { MenderArtifact } from '../services/mender.service';

export function formatArtifactLabel(artifact: MenderArtifact): string {
	if (artifact.description) {
		return `${artifact.name} - ${artifact.description}`;
	}
	return artifact.name;
}
